<template>
	<tr>
		<td>
			<span class="article-title"><strong>{{ user.name }}</strong></span>
			<div class="article-links">
				<a :href="'/' + $selectedSite.slug + '/providerPortalUsers/' + user.id +'/edit'"
				   v-if="userRoles.includes('provider_portal.users.update')">Edit</a>
			</div>
		</td>

		<td>{{ user.email }}</td>
		<td>{{ user.lastUpdated }}</td>
	</tr>
</template>

<script>
	export default {
		props: {
			dataUser: {
				type: Object,
			},
		},
		data() {
			return {
				user: this.dataUser,
				userRoles: this.$currentUserRoles,
			}
		}
	}
</script>
